import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { pure, compose, withHandlers } from 'react-recompose';
// common
import { hideListIssuesByListNameRequest } from '../common/actions';
// components
import IssueList from '../components/issue-list';
// helpers/constants
import * as G from '../helpers';
import * as GC from '../constants';
// hocs
import { withFixedPopover } from './with-fixed-popover';
//////////////////////////////////////////////////

export const withShowListIssues = ({ listName, getListRequestActionName }) => compose(
  connect(null, { hideListIssuesByListNameRequest }),
  withFixedPopover,
  withHandlers({
    handleHideIssues: (props) => (issues) => {
      const { reportType, closeFixedPopup, resetListAndPagination, hideListIssuesByListNameRequest } = props;

      const callback = () => {
        closeFixedPopup();
        resetListAndPagination();
        G.callFunctionWithArgs(G.getPropFromObject(getListRequestActionName, props), true);
      };

      const elements = R.map(R.prop(GC.FIELD_GUID), issues);

      return hideListIssuesByListNameRequest({ callback, elements, listName: R.or(listName, reportType) });
    },
  }),
  withHandlers({
    handleShowListIssues: (props) => (event, issues) => (
      props.openFixedPopup({
        version: 2,
        position: 'left',
        el: event.currentTarget,
        boxStyles: { zIndex: 10, borderRadius: 15 },
        content: <IssueList issues={issues} handleHideIssues={props.handleHideIssues} />,
      })
    ),
  }),
  pure,
);
